import React from 'react';
import { Trash2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
interface AdminServicesManagerProps {
  services: any[];
  setCreatePanel: (panel: any) => void;
  handleDeleteService: (id: number) => void;
  renderTableHeader: (title: string, count: number, onExport?: () => void, onCreate?: () => void, createLabel?: string) => React.ReactNode;
  generateCSV: (data: any[], name: string) => void;
}
export function AdminServicesManager({
  services,
  setCreatePanel,
  handleDeleteService,
  renderTableHeader,
  generateCSV
}: AdminServicesManagerProps) {
  return <div className="space-y-4" data-id="element-6026">
      {renderTableHeader('Услуги', services.length, () => generateCSV(services, 'services'), () => setCreatePanel({
      type: 'service',
      title: 'Добавить услугу'
    }), 'Добавить')}
      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-6027">
        <table className="w-full text-left" data-id="element-6028">
          <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-6029">
            <tr data-id="element-6030">
              <th className="px-3 py-2" data-id="element-6031">Название</th>
              <th className="px-3 py-2" data-id="element-6032">Тип</th>
              <th className="px-3 py-2" data-id="element-6033">Цена</th>
              <th className="px-3 py-2" data-id="element-6034">Статус</th>
              <th className="px-3 py-2" data-id="element-6035"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-6036">
            {services.map(s => <tr key={s.id} className="hover:bg-slate-50" data-id="element-6037">
                <td className="px-3 py-2 text-sm font-medium" data-id="element-6038">{s.title}</td>
                <td className="px-3 py-2 text-xs text-slate-500" data-id="element-6039">{s.type}</td>
                <td className="px-3 py-2 text-sm font-bold" data-id="element-6040">{s.price}</td>
                <td className="px-3 py-2" data-id="element-6041">
                  <Badge variant={s.active ? 'success' : 'neutral'} size="sm" data-id="element-6042">
                    {s.active ? 'Активна' : 'Выкл'}
                  </Badge>
                </td>
                <td className="px-3 py-2 text-right" data-id="element-6043">
                  <Button variant="ghost" size="sm" className="text-rose-500" icon={<Trash2 className="w-3 h-3" data-id="element-6045" />} onClick={() => handleDeleteService(s.id)} data-id="element-6044" />
                </td>
              </tr>)}
          </tbody>
        </table>
      </Card>
    </div>;
}